import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  containerHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& h1': {
      fontFamily: 'Sora',
      fontSize: '1.25rem',
      fontWeight: '600',
      lineHeight: '2rem',
    },
  },

  rootContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },

  cardLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    '& h5': {
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      padding: 0,
      margin: 0,
      paddingRight: '0.5rem',
    },
  },
}))

export { useStyles }
